'use client';
import InputNumber from "./InputNumber.js";
export default InputNumber;